import React from "react";
import "../styles/InvoiceDisplay.css";
import startingDateIcon from "../images/startingDateIcon.svg";
import endingDateIcon from "../images/endingDateIcon.svg";
import additionsIcon from "../images/additionsIcon.svg";
import deductionsIcon from "../images/deductionsIcon.svg";
import hoursWorkedIcon from "../images/hoursWorkedIcon.svg";
import minutesWorkedIcon from "../images/minutesWorkedIcon.svg";
import propertyIcon from "../images/propertyIcon.svg";
import salaryIcon from "../images/salaryIcon.svg";
import editInvoiceIcon from "../images/editInvoiceIcon.svg";
import deleteIcon from "../images/greyDeleteIcon.svg";

function formatInvoiceAdditions(additions) {
  const numericValue = Number(additions);
  if (Number.isNaN(numericValue)) {
    return "0.00";
  }
  return numericValue.toFixed(2);
}

function capitalizeFirstLetter(string) {
  const value = String(string || "");
  if (!value) return "";
  return value.charAt(0).toUpperCase() + value.slice(1);
}

function formatValue(value) {
  return value === "0.00" ? "-" : value;
}

const roundTwo = (num) =>
  Math.round((parseFloat(num || 0) + Number.EPSILON) * 100) / 100;

const calculateSubTotal = (formData) => {
  let amount = 0;

  if (formData.paymentType === "salary") {
    amount = roundTwo(formData.salary || 0);
  } else if (
    formData.paymentType === "hourly" ||
    formData.paymentType === "overtime"
  ) {
    const hours = parseFloat(formData.hours || 0);
    const minutes = parseFloat(formData.minutes || 0);

    let hoursWorked = hours + minutes / 60;

    hoursWorked = roundTwo(hoursWorked);

    const rate = parseFloat(formData.hourlyRate || 0);
    if (formData.paymentType === "overtime") {
      amount = roundTwo(hoursWorked * 1.5 * rate);
    } else {
      amount = roundTwo(hoursWorked * rate);
    }
  }
  return amount;
};

const calculateAmount = (formData) => {
  let amount = 0;

  if (formData.paymentType === "salary") {
    amount = roundTwo(formData.salary || 0);
  } else if (
    formData.paymentType === "hourly" ||
    formData.paymentType === "overtime"
  ) {
    let hours = parseFloat(formData.hours || 0);
    let minutes = parseFloat(formData.minutes || 0);

    let hoursWorked = roundTwo(hours + minutes / 60);

    const rate = parseFloat(formData.hourlyRate || 0);
    if (formData.paymentType === "overtime") {
      amount = roundTwo(hoursWorked * 1.5 * rate);
    } else {
      amount = roundTwo(hoursWorked * rate);
    }
  }
  // Adjust amount for additions and deductions
  const additions = roundTwo(formData.Additions || 0);
  const deductions = roundTwo(formData.Deductions || 0);

  amount = roundTwo(amount + additions - deductions);
  return amount;
};

const calculateSummary = (formDataList) => {
  let totalAdditions = 0;
  let totalDeductions = 0;
  let totalAmount = 0;
  let subTotal = 0;

  formDataList.forEach((formData) => {
    totalAdditions += parseFloat(formData.Additions || 0);
    totalDeductions += parseFloat(formData.Deductions || 0);
    totalAmount += parseFloat(calculateAmount(formData));
    subTotal += parseFloat(calculateSubTotal(formData));
  });

  return { totalAdditions, totalDeductions, totalAmount, subTotal };
};

const InvoiceDisplay = ({ formDataList, onDelete, onEdit }) => {
  const { totalAdditions, totalDeductions, totalAmount, subTotal } =
    calculateSummary(formDataList || []);
  const rows = Array.isArray(formDataList) ? formDataList : [];
  return (
    <div className="invoice-display-container">
      <div className="invoice-table-wrapper">
        <p className="invoice-display-information-txt">Information</p>
        <table className="invoice-display-table">
          <thead>
            <tr>
              <th>Property</th>
              <th>Type</th>
              <th>Value</th>
              <th>Additions</th>
              <th>Deductions</th>
              <th>Total</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((formData, index) => (
              <tr key={index}>
                <td>{formData.property}</td>
                <td>{capitalizeFirstLetter(formData.paymentType)}</td>
                <td>
                  {formData.paymentType === "salary"
                    ? `$${formatInvoiceAdditions(formData.salary || 0.0)}`
                    : `${formData.hours ?? 0}:${String(
                        formData.minutes ?? 0
                      ).padStart(2, "0")} hrs`}
                </td>
                <td>
                  <div>
                    <div>
                      {formatValue(
                        formatInvoiceAdditions(formData.Additions)
                      ) !== "-" && "$"}
                      {formatValue(formatInvoiceAdditions(formData.Additions))}
                    </div>
                    <div>
                      {formData.additionsType !== ""
                        ? `(${formData.additionsType})`
                        : ""}
                    </div>
                  </div>
                </td>
                <td>
                  <div>
                    {formatValue(
                      formatInvoiceAdditions(formData.Deductions)
                    ) !== "-" && "$"}
                    {formatValue(formatInvoiceAdditions(formData.Deductions))}
                  </div>
                  <div>
                    {formData.deductionsType !== ""
                      ? `(${formData.deductionsType})`
                      : ""}
                  </div>
                </td>
                <td>${formatInvoiceAdditions(calculateAmount(formData))}</td>
                <td>
                  <img
                    className="delete-icon admin-panel-icon invoice-display-icon invoice-display-edit-icon"
                    src={editInvoiceIcon}
                    alt="Edit Icon"
                    onClick={() => onEdit(index)}
                  />
                  <img
                    src={deleteIcon}
                    alt="Delete Icon"
                    className="delete-icon admin-panel-icon invoice-display-icon"
                    onClick={() => onDelete(index)}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <div className="summary">
          <div>
            <span className="generate-invoice-user-detail-left-text">
              Sub Total:
            </span>
            <span className="user-particular">
              {" "}
              ${formatInvoiceAdditions(subTotal)}
            </span>
          </div>
          <div>
            <span className="generate-invoice-user-detail-left-text">
              Additions:
            </span>
            <span className="user-particular">
              {" "}
              ${formatInvoiceAdditions(totalAdditions)}
            </span>
          </div>
          <div>
            <span className="generate-invoice-user-detail-left-text">
              Deductions:
            </span>
            <span className="user-particular">
              {" "}
              ${formatInvoiceAdditions(totalDeductions)}
            </span>
          </div>
          <div>
            <span className="generate-invoice-user-detail-left-text">
              Total:
            </span>
            <span className="user-particular total-amount-text">
              {" "}
              ${formatInvoiceAdditions(totalAmount)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceDisplay;
